import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function WorldClassScoreInfo({ testId = "world-class-score-info" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-label="Pourquoi le score World Class peut dépasser 100%"
          className="inline-flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
        >
          <Info className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="text-sm leading-relaxed" data-testid={`${testId}-content`}>
        <p className="font-semibold mb-1.5">Pourquoi le score World Class peut dépasser 100% ?</p>
        <p className="text-muted-foreground">
          Les 19 exigences World Class sont notées 0 / 0,5 / 1 / <strong>1,2</strong> point. Un score 4/4
          ("dépasse les attentes") vaut 1,2 point au lieu de 1, pour valoriser les sites qui vont au-delà
          de la simple conformité — le score peut donc monter jusqu'à 120%.
        </p>
        <p className="text-muted-foreground mt-1.5">
          Ce score est indépendant du score <strong>Minimum Requirements</strong> (sur 43 exigences, jamais
          supérieur à 100%), sur lequel portent les non-conformités.
        </p>
      </PopoverContent>
    </Popover>
  );
}
